// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
//This file is overridden with environment variables in the docker environment (see apps/GEA-Launchpad/nginx/nginx.conf)
import { Environment } from '@util/env';

export const environment: Environment = {
    production: true,
    name: window.env?.name ?? 'local',
    //GEA-ID
    baseUrlGeaIdAuth: window.env?.baseUrlGeaIdAuth ?? 'https://api.apps.tst.gea.com/',
    portalUrlGeaId: window.env?.portalUrlGeaId ?? 'https://portal.tst.gea.com/',
    // Azure AD B2C
    redirectUri: window.env?.redirectUri ?? 'https://dairynet.dev.gea.com/',
    postLogoutRedirectUri: window.env?.postLogoutRedirectUri ?? 'https://dairynet.dev.gea.com/',
    clientId: window.env?.clientId ?? 'e52d8574-e237-4840-a6b2-efda8cefbbd7',
    authority: window.env?.authority ?? 'https://login.portal.tst.gea.com/geaidtst.onmicrosoft.com/b2c_1_signin_signup',
    authorityDomain: window.env?.authorityDomain ?? 'login.portal.tst.gea.com',
    sharedLibraryStorageURL:
        window.env?.sharedLibraryStorageURL ?? 'https://content.apps.tst.gea.com/strg-container-b2c/',
    sharedLibraryIconStorageURL:
        window.env?.sharedLibraryIconStorageURL ??
        'https://content.apps.tst.gea.com/strg-container-apps/core/portal/icons/',
    sharedLibraryFTIconStorageURL:
        window.env?.sharedLibraryFTIconStorageURL ??
        'https://content.apps.tst.gea.com/strg-container-apps/ft/dairynetcloud/icons/',
    contactFormUrl: window.env?.contactFormUrl ?? 'https://support.apps.gea.com/',
    // Shared library localization
    sharedLibraryLocalizationStorageURL:
        window.env?.sharedLibraryLocalizationStorageURL ?? 'https://content.apps.tst.gea.com/strg-container-i18n/',
    geaAssetAppUrl: window.env?.geaAssetAppUrl ?? 'https://asset.apps.tst.gea.com/',
    geaSupportAppUrl: window.env?.geaSupportAppUrl ?? 'https://support.apps.tst.gea.com/',
    // Logbook Service
    basePathLogbook: '',
    // FarmSite Service
    basePathFarmSite: '',
    // Authorization Service
    basePathAuthorization: '',
    // PowerBi Service
    basePathPowerBi: '',
    // Event Service
    basePathEvent: '',
    // Backup Service
    basePathBackup: '',
    // ReleaseNotes Service
    basePathReleaseNotes: '',
    // UserConfig Service
    basePathUserConfig: '',
    // Translation Service
    basePathTranslation: '',
    // Property Service
    basePathProperty: '',
    // Remote Access Service
    basePathRemoteAccess: '',
    // Peak Service
    basePathPeak: '',
    // Enrollment Service
    basePathEnrollment: '',
    // License Service
    basePathLicense: '',
    // ProductOrder Service
    basePathProductOrder: '',
    // Subscription Service
    basePathSubscription: '',
    // Sam Data Service
    basePathSamDataService: '',
    basePathNotificationService: '',
    // System Monitoring Service
    basePathSystemMonitoring: '',
    // Billing Service
    basePathBilling: '',
    // MobileNotification Service
    basePathMobileNotifService: '',
    // Data Explorer Service
    basePathDataExplorerService: '',
    // Live View Data Service (DPQ Live View)
    basePathLiveViewDataService: '',
    basePathCoPilot: window.env?.basePathCoPilot ?? 'https://api.copilot.apps.dev.gea.com',
    applicationInsightsConnectionString:
        window.env?.applicationInsightsConnectionString ??
        'InstrumentationKey=60eb9438-3c6d-4349-a3cf-18059c253344;IngestionEndpoint=' +
            'https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    //OneTrust
    onetrustId: window.env?.onetrustId ?? 'bda0aab4-a4e9-49d5-abb1-3eed66267170-test',
    // SelfRegistry - given fallback sitekey does always block on any captcha attempt
    selfRegistryCaptchaSiteKey: window.env?.selfRegistryCaptchaSiteKey ?? '2x00000000000000000000AB',
    passwordResetAuthority:
        window.env?.passwordResetAuthority ??
        'https://login.portal.gea.com/geaid.onmicrosoft.com/B2C_1_RESET_PASSWORD_BY_EMAIL_VERIFICATION',
};
